const LINE_COLORS = [
	"#a6cee3",
	"#1f78b4",
	"#b2df8a",
	"#33a02c",
	"#fb9a99",
	"#e31a1c",
	"#fdbf6f",
	"#ff7f00",
	"#cab2d6",
	"#6a3d9a",
	"#b15928",
];

export function getLineColorByIndex(index: number): string {
	return LINE_COLORS[index % LINE_COLORS.length];
}
